import React from 'react';
import AnimatedSection from '../../components/AnimatedSection';
// 수정된 아이콘 임포트
import { HouseIcon, ShieldCheckIcon, LayersIcon, PaintRollerIcon } from '../../components/Icons'; 

const ServicesPage = () => { 
  const services = [
    { 
      name: "지붕 공사 및 신축 공사", 
      details: "주택, 공장, 상가 등 모든 건물의 노후된 지붕을 최신 공법과 자재로 안전하고 완벽하게 공사합니다. 신축 건물의 경우, 설계 단계부터 건물의 특성과 용도에 맞는 최적의 지붕 시스템을 제안하고 시공합니다.", 
      image: "https://placehold.co/800x600/0284c7/e0f2fe?text=Roof+Renovation", 
      icon: <HouseIcon className="w-8 h-8 text-sky-600 dark:text-sky-400"/> 
    },
    { 
      name: "옥상 및 외벽 방수 공사", 
      details: "건물 누수의 근본적인 원인을 정확히 진단하고, 우레탄 방수, 시트 방수 등 현장에 가장 적합한 방법으로 완벽한 방수층을 형성합니다. 철저한 시공으로 건물의 수명을 연장하고 자산 가치를 지킵니다.", 
      image: "https://placehold.co/800x600/0d9488/ccfbf1?text=Waterproofing", 
      icon: <ShieldCheckIcon className="w-8 h-8 text-teal-600 dark:text-teal-400"/> 
    },
    { 
      name: "징크 및 금속 지붕 시공", 
      details: "현대적인 디자인과 뛰어난 내구성을 자랑하는 징크, 컬러강판, 금속기와 등 다양한 금속 자재를 사용한 지붕을 전문적으로 시공합니다. 세련된 외관과 반영구적인 수명을 동시에 만족시켜 드립니다.", 
      image: "https://placehold.co/800x600/4338ca/e0e7ff?text=Metal+&+Zinc+Roofing", 
      icon: <LayersIcon className="w-8 h-8 text-indigo-600 dark:text-indigo-400"/> 
    },
    {
      name: "외벽 리모델링 및 마감",
      details: "지붕 공사와 함께 노후된 외벽을 리모델링하여 건물의 가치를 한 단계 끌어올립니다. 사이딩, 드라이비트, 석재 마감 등 다양한 솔루션으로 단열 성능 개선과 미관 향상을 동시에 실현합니다.",
      image: "https://placehold.co/800x600/be185d/fce7f3?text=Exterior+Remodeling",
      icon: <PaintRollerIcon className="w-8 h-8 text-pink-500" />
    }
  ];
  
  return (
    <>
      <title>전문 시공 분야 - 진양건설</title>
      <div className="container mx-auto px-6 py-16 md:py-24 space-y-16">
        <AnimatedSection animationType="fade-in">
          <header className="text-center pt-8 pb-12 rounded-lg">
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 dark:text-white tracking-tight">전문 시공 분야</h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">진양건설은 지붕 및 외벽 공사에 대한 최고의 기술력과 노하우를 보유하고 있습니다.</p>
          </header>
        </AnimatedSection>

        {services.map((service, index) => (
          <AnimatedSection 
            key={index} 
            className={`bg-white dark:bg-slate-800 rounded-xl shadow-2xl overflow-hidden flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} 
            animationType={index % 2 === 0 ? "fade-in-right" : "fade-in-left"}
          >
            <div className="md:w-1/2">
              <img 
                src={service.image} 
                alt={service.name} 
                className="w-full h-80 md:h-full object-cover" 
                onError={(e) => e.target.src = 'https://placehold.co/800x600/334155/e0f2fe?text=Service+Error'}
              />
            </div>
            <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-4">
                {service.icon}
                <h2 className="ml-3 text-3xl md:text-4xl font-bold text-gray-800 dark:text-white">{service.name}</h2>
              </div>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-lg">{service.details}</p>
            </div>
          </AnimatedSection>
        ))}
      </div>
    </>
  );
}
export default ServicesPage;
